import { z } from 'zod';
import { preprocessStringNumberSchema } from '../../preprocess-string-number';

export const FULL_BGP_LIMIT_MIN = 1;
export const FULL_BGP_LIMIT_MAX = 10_000_000;

export const fullBgpLimitSchemaZ = z.object({
  enabled: z.boolean(),
  // TODO: NIM-22108 Remove preprocess after frontend is fixed
  threshold: preprocessStringNumberSchema(
    z
      .number()
      .safe()
      .min(FULL_BGP_LIMIT_MIN)
      .max(FULL_BGP_LIMIT_MAX)
      .optional(),
  ),
});
